module.exports = __webpack_public_path__ + "static/media/code-fork-solid.01d0f46e.svg";